"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUSH_NOTIFICATION_TRIGGER_TYPE = exports.NOTIFICATION_DB_TYPE = exports.NOTIFICATION_SUBTYPE = exports.NOTIFICATION_TYPE = exports.NOTIFICATION_DATE_RANGE = exports.ATTACHEMENT_TYPE = void 0;
var ATTACHEMENT_TYPE;
(function (ATTACHEMENT_TYPE) {
    ATTACHEMENT_TYPE["CSV"] = "CSV";
    ATTACHEMENT_TYPE["EXCEL"] = "EXCEL";
})(ATTACHEMENT_TYPE || (exports.ATTACHEMENT_TYPE = ATTACHEMENT_TYPE = {}));
var NOTIFICATION_DATE_RANGE;
(function (NOTIFICATION_DATE_RANGE) {
    NOTIFICATION_DATE_RANGE["TODAY"] = "TODAY";
    NOTIFICATION_DATE_RANGE["YESTERDAY"] = "YESTERDAY";
    NOTIFICATION_DATE_RANGE["LAST_FULL_WEEK"] = "LAST_FULL_WEEK";
    NOTIFICATION_DATE_RANGE["CURRENT_WEEK"] = "CURRENT_WEEK";
    NOTIFICATION_DATE_RANGE["LAST_FULL_MONTH"] = "LAST_FULL_MONTH";
    NOTIFICATION_DATE_RANGE["CURRENT_MONTH"] = "CURRENT_MONTH";
    NOTIFICATION_DATE_RANGE["CURRENT_YEAR"] = "CURRENT_YEAR";
})(NOTIFICATION_DATE_RANGE || (exports.NOTIFICATION_DATE_RANGE = NOTIFICATION_DATE_RANGE = {}));
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["EMAIL"] = "EMAIL";
    NOTIFICATION_TYPE["SMS"] = "SMS";
    NOTIFICATION_TYPE["PUSH"] = "PUSH";
    NOTIFICATION_TYPE["MESSAGING_APP"] = "MESSAGING_APP";
})(NOTIFICATION_TYPE || (exports.NOTIFICATION_TYPE = NOTIFICATION_TYPE = {}));
var NOTIFICATION_SUBTYPE;
(function (NOTIFICATION_SUBTYPE) {
    NOTIFICATION_SUBTYPE["ZALO"] = "ZALO";
})(NOTIFICATION_SUBTYPE || (exports.NOTIFICATION_SUBTYPE = NOTIFICATION_SUBTYPE = {}));
var NOTIFICATION_DB_TYPE;
(function (NOTIFICATION_DB_TYPE) {
    NOTIFICATION_DB_TYPE["POSTGRES"] = "POSTGRES";
    NOTIFICATION_DB_TYPE["BIGQUERY"] = "BIGQUERY";
})(NOTIFICATION_DB_TYPE || (exports.NOTIFICATION_DB_TYPE = NOTIFICATION_DB_TYPE = {}));
var PUSH_NOTIFICATION_TRIGGER_TYPE;
(function (PUSH_NOTIFICATION_TRIGGER_TYPE) {
    PUSH_NOTIFICATION_TRIGGER_TYPE["WORKFLOW_STATUS_UPDATE"] = "WORKFLOW_STATUS_UPDATE";
    PUSH_NOTIFICATION_TRIGGER_TYPE["STEP_STATUS_UPDATE"] = "STEP_STATUS_UPDATE";
    PUSH_NOTIFICATION_TRIGGER_TYPE["STEP_ASSIGNMENT_UPDATE"] = "STEP_ASSIGNMENT_UPDATE";
})(PUSH_NOTIFICATION_TRIGGER_TYPE || (exports.PUSH_NOTIFICATION_TRIGGER_TYPE = PUSH_NOTIFICATION_TRIGGER_TYPE = {}));
